import type {
  ApplyKeyPresetActivationRequest,
  ApplyKeyPresetActivationResponse,
  PreviewKeyPresetActivationRequest,
  PreviewKeyPresetActivationResponse,
  RollbackKeyPresetActivationResponse,
} from '@nadoutong/contracts';
import { opsApiRequest } from './client.ts';

const BASE_PATH = '/v1/ops/key-preset-activations';

export function previewKeyPresetActivation(
  body: PreviewKeyPresetActivationRequest,
  fetchImpl: typeof fetch = fetch,
): Promise<PreviewKeyPresetActivationResponse> {
  return opsApiRequest<PreviewKeyPresetActivationResponse>(`${BASE_PATH}/preview`, {
    method: 'POST',
    body,
  }, fetchImpl);
}

export function applyKeyPresetActivation(
  body: ApplyKeyPresetActivationRequest,
  fetchImpl: typeof fetch = fetch,
): Promise<ApplyKeyPresetActivationResponse> {
  return opsApiRequest<ApplyKeyPresetActivationResponse>(`${BASE_PATH}/apply`, {
    method: 'POST',
    body,
  }, fetchImpl);
}

export function rollbackKeyPresetActivation(
  operationId: string,
  fetchImpl: typeof fetch = fetch,
): Promise<RollbackKeyPresetActivationResponse> {
  return opsApiRequest<RollbackKeyPresetActivationResponse>(
    `${BASE_PATH}/${encodeURIComponent(operationId)}/rollback`,
    { method: 'POST' },
    fetchImpl,
  );
}

export function createKeyPresetOperationId(): string {
  if (globalThis.crypto !== undefined && 'randomUUID' in globalThis.crypto) {
    return globalThis.crypto.randomUUID();
  }
  return `preset-${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 10)}`;
}
